import {type WeavePanelSlateNode} from '@wandb/weave/components/Panel2/ChildPanelExportReport/computeReportSlateNode';
import {type Element, type Node} from 'slate';

import {type RootQueryPanelConfig} from '../../Panel2/RootQueryPanel';

export interface WeavePanel extends Element {
  type: 'weave-panel';
  config: RootQueryPanelConfig;
}

export type Weave1Panel = WeavePanelSlateNode;

export const isWeavePanel = (node: Node): node is WeavePanel =>
  node.type === 'weave-panel';

export const isWeave1Panel = (node: Node): node is Weave1Panel =>
  isWeavePanel(node) && node.config?.isWeave1Panel === true;

export interface WeavePythonPanel extends Element {
  type: 'weave-python-panel';
  config: RootQueryPanelConfig;
}

export const isWeavePythonPanel = (node: Node): node is WeavePythonPanel =>
  node.type === 'weave-python-panel';
